module.exports = __webpack_public_path__ + "img/bear4.15bd6c78.svg";